import { Routes, Route } from "react-router-dom";
import React, { useEffect, useState } from "react";

// Layout & Pages
import MainLayout from "./Layout/MainLayout";
import Dashboard from "./Pages/Dashboard";
import Publishers from "./Pages/Publishers";
import WebAnalytics from "./Pages/WebAnalytics";
import AppAnalytics from "./Pages/AppAnalytics";
import AppsWebsites from "./Pages/AppsWebsites";
import SettingsPage from "./Pages/Settings";
import Login from "./Pages/Login";

// Auth
import ProtectedRoute from "./Auth/ProtectedRoute";

// UI/UX Enhancements
import CursorClickEffect from "./Components/Animations/CursorClickEffect";
import Toast from "./Components/Animations/Toast";
import Adunits from "./Pages/Adunits";
import PublisherPayments from "./Pages/PublisherPayments";
import AdminPublisherPayments from "./Pages/AdminPublisherPayments";
import InvoicesPage from "./Pages/InvoicesPage";
import PublisherBankDetails from "./Pages/PublisherBankDetails";
import PublisherInvoicesPage from "./Pages/PublisherInvoicesPage";
import UserManagement from "./Pages/UserManagement";
// import AnimatedCursor from "./Components/Animations/AnimatedCursor"; // Optional if needed

function App() {
  const [showUpdateToast, setShowUpdateToast] = useState(false);
  const appVersion = "1.1.0";

  useEffect(() => {
    const storedVersion = localStorage.getItem("appVersion");

    // Show toast only if a stored version exists and it's different from current
    if (storedVersion && storedVersion !== appVersion) {
      setShowUpdateToast(true);
    }

    // Always update localStorage with current version
    if (storedVersion !== appVersion) {
      localStorage.setItem("appVersion", appVersion);
    }
  }, []);

  return (
    <>
      {/* Optional Custom Cursor */}
      {/* <AnimatedCursor /> */}
      <CursorClickEffect />

      {/* Show update toast if app version changed */}
      {showUpdateToast && (
        <Toast
          message="A new version of the app is available!"
          subMessage="Refresh to get the latest features and improvements."
          type="info"
          autoClose={false}
          position="bottom-right"
          actions={[
            {
              label: "Refresh Now",
              handler: () => window.location.reload(),
              variant: "primary",
            },
            {
              label: "Later",
              handler: () => setShowUpdateToast(false),
              variant: "text",
            },
          ]}
        />
      )}

      <Routes>
        {/* Public route */}
        <Route path="/login" element={<Login />} />

        {/* Protected Routes */}
        <Route
          path="/"
          element={
            <ProtectedRoute>
              <MainLayout />
            </ProtectedRoute>
          }
        >
          <Route index element={<Dashboard />} />
          <Route path="publishers" element={<Publishers />} />
          <Route path="web-analytics" element={<WebAnalytics />} />
          <Route path="app-analytics" element={<AppAnalytics />} />
          <Route path="apps" element={<AppsWebsites />} />
          <Route path="ad-units" element={<Adunits />} />
          <Route path="payment-info" element={<PublisherPayments />} />
          {/* <Route path="payment-info" element={<PublisherBankDetails />} /> */}
          <Route path="admin-payment-info" element={<AdminPublisherPayments />} />
          <Route path="settings" element={<SettingsPage />} />
          <Route path="invoice" element={<InvoicesPage />} />
          <Route path="publisher-invoice" element={<PublisherInvoicesPage />} />
          <Route path="user-management" element={<UserManagement />} />
        </Route>
      </Routes>
    </>
  );
}

export default App;
